<!--
商品列表项
20200331
-->
<template>
  <div class="item_goods">
    <div class="item_goods_box" @click.stop.prevent="clickGoto(false)">
    <!-- <router-link class="item_goods" :to="goto"> -->
      <slot name="check"></slot>
      <div class="cover_wrap" @click.stop.prevent="clickGoto(true)">
        <div class="cover image"
          v-lazy:background-image="{
            src: goods_item.cover,
            error: $store.state.externalurl.GIANT_CDN + '/img/img_blank.png'
          }"
        ></div>
        <slot name="cover_extra"></slot>
      </div>
      <div class="item_goods_content">
        <slot name="title">
          <div class="title_wrap" @click.stop.prevent="clickGoto(true)">
            <div class="title">{{goods_item.title ? goods_item.title : '--'}}</div>
            <div class="subtitle">{{goods_item.subtitle}}</div>
            <slot name="goodsattr">

            </slot>

          </div>
        </slot>
        <div class="price_wrap">
          <slot name="price">
            <template v-if="goods_item.goods_type != 3">
              <div class="price_deduction" v-show="Number(goods_item.deduction_max_price) > 0 && Number(goods_item.deduction_max_points) > 0">积分最多可抵扣<span class="num">{{goods_item.deduction_max_price}}</span>元</div>
            </template>

            <template v-if="goods_item.goods_type != 3">
              <div class="price_p">
                <em
                  v-for="(price_p_n, price_p_i) in goods_item.price_p"
                  :key="price_p_i"
                >{{price_p_n}}</em>
              </div>
              <div class="price_now"><small>￥</small>{{goods_item.price_now ? goods_item.price_now : '--'}}</div>
              <div class="price_o" v-show="goods_item.price_o"><small>￥</small>{{goods_item.price_o}}</div>
            </template>
            <div class="price_now" v-else><small>积分</small>{{goods_item.deduction_max_points ? goods_item.deduction_max_points : '--'}}</div>
            <div class="total_sales" v-show="goods_item.total_sales > 0">已售 {{goods_item.total_sales}}</div>
          </slot>
        </div>
      </div>
      <div class="btnbox">
        <slot name="btnbox">
          <!--<div class="btn_order btn btn_color_1 btn_shadow btn_round" @click.stop.prevent="goodsframe_btn(goods_item.id)"><i class="material-icons">&#xe854;</i><span>订购</span></div>-->
        </slot>
      </div>
    <!-- </router-link> -->
      <template v-if="hrefmask">
        <router-link class="hrefmask" :to="goto" v-if="typeof(goto) == 'object'"></router-link>
        <a class="hrefmask" :href="goto" v-else-if="goto && typeof(goto) == 'string'"></a>
      </template>
    </div>
    <slot name="extra"></slot>
  </div>
</template>

<script>

export default {
  name: 'Goods',
  components: {},
  props: {
    goods_item: Object,
    goto: [Object, Boolean, String],
    //是否是复杂跳转 true 头图、标题等可点击 false 整个卡片可点击
    isComplex: {
      type: Boolean,
      default: false
    },
    //是否增加A链接跳转遮盖层，便于复制链接、开新窗口
    //开启本开关后，isComplex 基本失效
    hrefmask: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  created() {
    const _this = this;

  },
  mounted() {

  },
  destroyed() {},
  methods: {
    clickGoto( model ){
      const _this = this;
      console.log(_this.goto);
      if( !_this.isComplex || ( _this.isComplex == model ) ){
        if(!_this.goto){
          //啥也不干
        } else if(typeof _this.goto == "string"){
          location.href = _this.goto;
        } else {
          _this.$router.push(_this.goto);
        }
      }
    },

  }
}
</script>



<style lang="less">

@bluecolor: #4E66FF;


/** 商品列表项 **/
.item_goods {
  position: relative;
  transition: all 0.3s;
  cursor: pointer;
}
.item_goods_box {
  position: relative;
  display: flex;
  /*align-items: center;*/
  //border-bottom: 1px solid #eee;
  background-color: #fff;
  transition: all 0.3s;
  .cover_wrap {
    width: 90px;
    flex-shrink: 0;
    transition: all 0.3s;
    align-self: center;
    //margin-left: 10px;
    .cover {
      display: block;
      width: 100%;
      height: auto;
      padding-top: 100%;
      /*background-image: url(../img/img_blank.png);*/
      background-size: contain;
      background-color: #f7f7f7;
    }
  }
  .item_goods_content {
    flex: 1;
    position: relative;
    display: block;
    font-size: 12px;
    padding: 0 15px 5px 0;
    overflow: hidden;
    transition: all 0.3s;
    align-self: center;
    //border-bottom: 1px solid #eee;
    margin-left: 15px;
    margin-bottom: 10px;
    margin-top: 10px;
    .title_wrap {
      margin-bottom: 10px;;
      .title {
        font-size: 14px;
        font-weight: 700;
        color: rgba(0, 0, 0, 1);
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -MOZ-box-orient:vertical;
        -webkit-line-clamp:2;
        -MOZ-line-clamp:2;
        word-wrap:break-word;
        word-break:break-all;
        // padding-right: 55px;
      }
      .subtitle {
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        min-height: 16px;
        margin-top: 5px;
      }
      .goodsattr {
        position: absolute;
        top: 6px;
        right: 0;
        color: #5f75fe;
      }
    }
    .price_wrap {
      .price_deduction {
        color: #f4330d;
        .num {
          font-weight: bold;
        }
      }
      .price_p {
        transform: scale(.8);
        transform-origin: 100%;
        em {
          display: inline-block;
          font-style: normal;
          background-color: #f4330d;
          color: #fff;
          border-radius: 3px;
          padding: 0 5px;
          font-size: 12px;
          line-height: 20px;
          height: 20px;
          margin-left: 5px;
        }
      }
      .price_o {
        display: inline-block;
        color: #a5a5a5;
        font-size: 12px;
        text-decoration: line-through;
      }
      .price_now {
        display: inline-block;
        font-weight: bold;
        color: #f4330d;
        font-size: 16px;
        padding-right: 5px;
      }
      .total_sales {
        display: inline-block;
        color: #a5a5a5;
        font-size: 12px;
      }
    }
  }
  .btnbox {
    flex-shrink: 0;
    padding-right: 5px;
    .btn {
      padding: 0 15px;
      line-height: 40px;
    }
  }
  .hrefmask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}


.mode_grid {
  display: flex;
  flex-wrap: wrap;
  margin: -2.5px;
  transition: all 0.3s;
  .item_goods {
    flex: 0 0 50%;
    overflow: hidden;
    padding: 2.5px;
    display: flex;
    .item_goods_box {
      width: 100%;
      display: block;
      padding-bottom: 10px;
      /*margin-right: 2%;*/
      overflow: hidden;
      border-bottom: none;
      margin-bottom: 1px;
      box-shadow: 0 1px 3px rgba(0,0,0,.1);
      border-radius: 5px;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .cover_wrap {
        width: 100%;
      }
      .item_goods_box {
        padding: 5px 10px;
      }
    }
  }

}

</style>


<style lang="less" scoped>
@bluecolor: #4E66FF;

.item_goods {
  .badge {
    margin: 0 5px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Goods.vue